import { ButtonRoot } from '@/components/common/Button'
import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { viewActions } from '@/store/view'
import { getClickawayIgnoreProps } from '@/utils/clickawayUtil'
import { cn } from '@/utils/commonUtil'

import styles from './HeaderButtonNav.module.scss'

export const HeaderButtonNav = () => {
  const dispatch = useReduxDispatch()
  const isNavOpen = useReduxSelector((s) => s.view.mobileStatus === 'nav')

  const onClick = () => {
    dispatch(viewActions.toggleMobileStatus('nav'))
  }

  return (
    <ButtonRoot
      className={cn(styles.container, { isNavOpen, styles })}
      onClick={onClick}
      {...getClickawayIgnoreProps(['collapse-expanded'])}
    >
      <div className={styles.graphic}>
        <div aria-hidden></div>
        <div aria-hidden></div>
        <div aria-hidden></div>
        <span className='visually-hidden'>Menu</span>
      </div>
    </ButtonRoot>
  )
}
